<template>
    <v-row class="ma-0">
		<v-col class="pa-0" cols="12">
			<v-card class="mb-2 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Mail automatiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>				
				<v-divider></v-divider>
				<v-list three-line subheader class="background-2 pa-2">
					<v-list-item>
						<v-list-item-action>
							<v-checkbox color="primary" v-model="settings['enable_mail_scheduling']"></v-checkbox>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>Mail automatiche</v-list-item-title>
							<v-list-item-subtitle>Attiva l'invio automatico di email ai clienti che hanno raggiunto un certo volume di acquisti
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
		<v-col class="pa-0 pt-3" cols="12">
			<crud
				title="Scheduling Mail automatiche"
				action-icon='repeat'
				model-def='companiesmailsschedules'
				action-position='absolute'
				url="companiesmailsschedules-filters"
			></crud>		
		</v-col>		
    </v-row>
</template>
<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

	export default {
		name:'companies-scheduling-options',
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				snackbar: false,
				model: 'company',
				settings: {
				    'enable_mail_scheduling': false,
				},
			}
		},
	}
</script>
